import './Service.css'

const Service = ({ title, description, image }) => {
    return (
        <div className={"col-md-4 col-lg-4 col-sm-12 col-xs-12"}>
            <div className="service animate">
                <div className="service-description">
                    <span className={"desc"}>{description}</span>
                </div>
                <img src={image} alt={title} />
                <h3>{title}</h3>
            </div>
        </div>
    )
}

export default Service;
